import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as _ from "lodash";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SendOrderService {
  constructor(private http: HttpClient) { }
  private url = "https://us-central1-chicken-station--yigal-alon.cloudfunctions.net/orders";

  pushOrder(order)  : Observable<Object> {
    return this.http.post(
      `${this.url}/sendOrder`,
      order
    );
  }

}
